import parser from './parser.services'
var lastLevelId = 0
var lastOrderReversed = false
var lastRandValues = {}

export function buildLevel(level) {
    if (lastLevelId !== level.id) {
        lastLevelId = level.id
        lastRandValues = {}
    }
    switch (level.type) {
        default:
            return buildStdLevel(level.settings)
    }
}

function buildStdLevel(settings) {
    let quantities = getValues(settings)
    if (settings.value_display_order === 'reversed') {
        let value_1 = +quantities.value_1
        let value_2 = +quantities.value_2
        let value_3 = +quantities.value_3
        if(value_3){
            quantities.value_1 = +value_2
            quantities.value_2 = +value_3
            quantities.value_3 = +value_1
        } else {
            quantities.value_1 = +value_2
            quantities.value_2 = +value_1
        }
    } else if (settings.value_display_order === 'mixed') {
        if (lastOrderReversed) {
            lastOrderReversed = false
        } else {
            lastOrderReversed = true
            let value_1 = +quantities.value_1
            let value_2 = +quantities.value_2
            let value_3 = +quantities.value_3
            if(value_3){
                quantities.value_1 = +value_2
                quantities.value_2 = +value_3
                quantities.value_3 = +value_1
            } else {
                quantities.value_1 = +value_2
                quantities.value_2 = +value_1
            }
        }
    }
    quantities = completeValues(quantities, settings.operation)
    quantities = removeNegativeAnswer(quantities, settings.operation)
    quantities = removeNullValues(quantities)
    return {
        quantities,
        operation: settings.operation
    }
}

function getValues(settings) {
    let withVars = []
    let value_1 = settings.value_1
    let value_2 = settings.value_2
    let value_3 = settings.value_3
    let answer = settings.answer
    let values = {
        value_1: null,
        value_2: null,
        value_3: null,
        answer: null
    }
    if (value_1) {
        let settings = parser.parseSettings(value_1)
        value_1 = parser.trimSettings(value_1)
        if (parser.hasVariables(value_1)) {
            withVars.push({ key: 'value_1', value: value_1, settings })
        } else {
            values.value_1 = parser.parseFormula(value_1, settings)
            values.value_1 = getRandFromRange(values.value_1, 'value_1', settings)
        }
    }
    if (value_2) {
        let settings = parser.parseSettings(value_2)
        value_2 = parser.trimSettings(value_2)
        if (parser.hasVariables(value_2)) {
            withVars.push({ key: 'value_2', value: value_2, settings })
        } else {
            values.value_2 = parser.parseFormula(value_2, settings)
            values.value_2 = getRandFromRange(values.value_2, 'value_2', settings)
        }
    }
    if (value_3) {
        let settings = parser.parseSettings(value_3)
        value_3 = parser.trimSettings(value_3)
        if (parser.hasVariables(value_3)) {
            withVars.push({ key: 'value_3', value: value_3, settings })
        } else {
            values.value_3 = parser.parseFormula(value_3, settings)
            values.value_3 = getRandFromRange(values.value_3, 'value_3', settings)
        }
    }
    if (answer) {
        let settings = parser.parseSettings(answer)
        answer = parser.trimSettings(answer)
        if (parser.hasVariables(answer)) {
            withVars.push({ key: 'answer', value: answer, settings })
        } else {
            values.answer = parser.parseFormula(answer, settings)
            values.answer = getRandFromRange(values.answer, 'answer', settings)
        }
    }
    let i = 0
    while (withVars.length > 0 && i < 100) {
        let valueObject = withVars.shift()
        let settings = valueObject.settings
        values[valueObject.key] = parser.parseVariables(valueObject.value, values, settings)
        if (values[valueObject.key]) {
            values[valueObject.key] = parser.parseFormula(values[valueObject.key], settings)
            values[valueObject.key] = getRandFromRange(values[valueObject.key], settings)
        } else {
            withVars.push(valueObject)
        }
        i++
    }

    return values
}

function getRandFromRange(rangeString, key, settings = {}) {
    let rand = 0;
    let range = parser.parseRange(rangeString, settings)
    if (range.length > 1) {
        let iteration = 0
        if (!(lastRandValues[key] instanceof Array) ) {
            lastRandValues[key] = []
        }else if(lastRandValues[key].length >= range.length || lastRandValues[key].length > 2){
            lastRandValues[key].shift()
        }
        do {
            rand = Math.floor(Math.random() * (range.length))
            iteration += 1
        }
        while (lastRandValues[key].includes(range[rand]) && iteration <= 100)
        lastRandValues[key].push(range[rand])
    }

    return range[rand]
}

function completeValues(values, operation) {
    let answer = values.answer
    let value_1 = values.value_1
    let value_2 = values.value_2
    let value_3 = values.value_3
    if (answer) {
        if (operation === 'addition' && +value_1 + +value_2 + +value_3 !== answer) {
            if (isNaN(value_1) || null === value_1) {
                values.value_1 = Math.abs(answer - (+value_2 + +value_3))
            } else if (isNaN(value_2) || null === value_2) {
                values.value_2 = Math.abs(answer - (+value_1 + +value_3))
            } else if (+value_1 + +value_2 !== answer) {
                values.value_3 = Math.abs(answer - (+value_1 + +value_2))
            }
        } else if (operation === 'subtraction' && value_1 - value_2 - value_3 !== answer) {
            if (isNaN(value_1) || null === value_1) {
                values.value_1 = Math.abs(answer + +value_2 + +value_3)
            } else if (isNaN(value_2) || null === value_2) {
                values.value_2 = Math.abs(value_1 - value_3 - answer)
            } else if (value_1 - value_2 !== answer) {
                values.value_3 = Math.abs(value_1 - value_2 - answer)
            }
        }
    }
    return values
}

function removeNullValues(values) {
    values.answer = values.answer === null ? 0 : values.answer
    values.value_1 = values.value_1 === null ? 0 : values.value_1
    values.value_2 = values.value_2 === null ? 0 : values.value_2
    values.value_3 = values.value_3 === null ? 0 : values.value_3

    return values
}

function removeNegativeAnswer(values, operation) {
    let answer = values.answer
    let value_1 = values.value_1
    let value_2 = values.value_2
    let value_3 = values.value_3
    if (operation === 'subtraction' && value_1 < (+value_2 + +value_3)) {
        values.value_1 = +value_2 + +value_3
    }
    return values
}


// WEBPACK FOOTER //
// ./src/services/game.services.js